import { NgModule } from '@angular/core';

import {
	UiNewButtonBasicComponent,
	UiNewButtonFilledComponent,
	UiNewButtonIconComponent,
	UiNewButtonOutlineComponent,
} from './components';

const buttons = [
	UiNewButtonBasicComponent,
	UiNewButtonIconComponent,
	UiNewButtonFilledComponent,
	UiNewButtonOutlineComponent,
];

export * from './components';

@NgModule({
	imports: buttons,
	exports: buttons,
})
export class UiNewButtons {}
